<template>
  <div class="contact-wrapper flex-col">
    <div class="box_25 flex-row justify-between">
      <img
        class="image_7"
        referrerpolicy="no-referrer"
        :src="image7Src"
      />
      <span class="text_80">联系我们</span>
      <img
        class="image_4"
        referrerpolicy="no-referrer"
        :src="image4Src"
      />
    </div>
    <!-- 联系信息部分 -->
    <div class="footer-section flex-col">
      <img
        class="footer-decorative-image"
        referrerpolicy="no-referrer"
        :src="image5Src"
      />
      <div class="footer-title flex-row"><span class="footer-title-text">CONTACT&nbsp;US</span></div>
      <div class="footer-contact flex-row">
        <div class="footer-phone flex-col justify-between">
          <div class="footer-phone-icon flex-col">
            <img
              class="footer-phone-img"
              referrerpolicy="no-referrer"
              src="../assets/img/footer-phone.png"
            />
          </div>
          <div class="footer-phone-text flex-col justify-between">
            <span class="footer-phone-label">电话</span>
            <span class="footer-phone-number">{{ siteConfig?.tel || '021-59506101' }}</span>
          </div>
        </div>
        <div class="footer-qrcode flex-col">
          <img
            v-if="siteConfig && siteConfig.qrcode"
            :src="getImageUrl(siteConfig.qrcode)"
            alt="二维码"
            class="footer-qrcode-img"
            referrerpolicy="no-referrer"
          />
        </div>
        <div class="footer-address flex-col">
          <div class="footer-address-icon flex-col">
            <img
              class="footer-address-img"
              referrerpolicy="no-referrer"
              src="../assets/img/footer-address.png"
            />
          </div>
          <span class="footer-address-label">地址</span>
          <span class="footer-address-text" v-html="siteConfig?.addr || '上海市嘉定区嘉松北路3485号<br />伊宁路2688号（国际赛车场西侧）'"></span>
        </div>
      </div>
    </div>
    <!-- 底部导航和版权信息 -->
    <div class="footer-bottom flex-col">
      <div class="footer-menu flex-row">
        <router-link to="/" class="footer-menu-item">首页</router-link>
        <div class="footer-menu-divider flex-col"></div>
        <router-link to="/lanhu_guanyuwomen" class="footer-menu-item">关于我们</router-link>
        <div class="footer-menu-divider flex-col"></div>
        <router-link to="/service" class="footer-menu-item">服务项目</router-link>
        <div class="footer-menu-divider flex-col"></div>
        <router-link to="/news" class="footer-menu-item">新闻资讯</router-link>
        <div class="footer-menu-divider flex-col"></div>
        <router-link to="/reserve" class="footer-menu-item">预约咨询</router-link>
        <div class="footer-menu-divider flex-col"></div>
        <router-link to="/lanhu_muxingzhanshi" class="footer-menu-item">墓型展示</router-link>
        <div class="footer-menu-divider flex-col"></div>
        <router-link to="/lanhu_zaixianjidian" class="footer-menu-item">人文纪念</router-link>
        <div class="footer-menu-divider flex-col"></div>
        <router-link to="/lanhu_zaixiangoumu" class="footer-menu-item">在线购墓</router-link>
      </div>
      <div class="footer-copyright flex-row">
        <span class="footer-copyright-text">
          Copyright&nbsp;©&nbsp;2025-2030&nbsp;changshanlingyuan.com.cn&nbsp;All&nbsp;Rights&nbsp;Reserved.&nbsp;&nbsp;&nbsp;&nbsp;版权所有&nbsp;&nbsp;正定县常山陵园&nbsp;&nbsp;&nbsp;&nbsp;备案号：冀ICP备2025139742号
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getSiteConfig } from '@/store/siteConfig';
import { getImageUrl } from '@/config/api';

export default {
  name: 'ContactUsSection',
  data() {
    return {
      siteConfig: null,
      image4Src: require('@/views/lanhu_zaixiangoumu/assets/img/1459914e994bb6beda276f741adbbfd1.png'),
      image5Src: require('@/views/lanhu_zaixiangoumu/assets/img/f388062b951de4e5f7b687f19e8c4c8d.png'),
      image7Src: require('@/views/lanhu_zaixiangoumu/assets/img/c7cc2d9111869439f5b9b0ea2b766901.png')
    };
  },
  created() {
    // 获取网站配置
    this.siteConfig = getSiteConfig();
  },
  methods: {
    getImageUrl(imgPath) {
      return getImageUrl(imgPath);
    }
  }
};
</script>

<style scoped>
/* 联系我们部分独立容器 */
.contact-wrapper {
  position: relative;
  width: 100%;
  margin-top: 100px;
}

/* box_25 自适应 - 左中右布局 */
.box_25 {
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 39px !important;
  margin: 10px auto 0 !important;
  padding: 0 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: row ;
  justify-content: space-between !important; /* 左中右分布 */
  align-items: center !important;
  gap: 20px !important;
}

/* text_80 自适应 - 始终在屏幕中间 */
.text_80 {
  display: none !important; /* 隐藏"联系我们"文字 */
  width: auto !important;
  max-width: 193px !important;
  height: auto !important;
  min-height: 43px !important;
  overflow-wrap: break-word !important;
  color: rgba(140, 48, 0, 1) !important;
  font-size: clamp(32px, 4vw, 47px) !important; /* 响应式字体 */
  font-family: STKaitiSC-Bold !important;
  font-weight: 700 !important;
  text-align: center !important; /* 文字居中 */
  white-space: nowrap !important;
  line-height: 1.2 !important;
  flex: 0 0 auto !important;
  margin: 0 auto !important; /* 水平居中 */
  order: 2 !important; /* 中间位置 */
}

/* image_4 自适应 - 右侧 */
.image_4 {
  width: 100% !important;
  max-width: 600px !important; /* 缩小图片 */
  height: auto !important;
  min-height: 59px !important;
  margin: 0 !important;
  object-fit: contain !important;
  flex: 0 0 auto !important;
  order: 3 !important; /* 右侧位置 */
}

.image_5 {
  position: relative !important;
  display: block !important;
  width: 113px;
  height: 249px;
  margin: 83px 0 107px 104px !important;
}

/* image_7 自适应 - 左侧 */
.image_7 {
  position: relative !important;
  left: auto !important; /* 移除固定定位 */
  top: auto !important; /* 移除固定定位 */
  display: block !important;
  width: 100% !important;
  max-width: 600px !important; /* 缩小图片 */
  height: auto !important;
  min-height: 59px !important;
  margin: 0 !important; /* 移除 margin */
  object-fit: contain !important;
  flex: 0 0 auto !important;
  order: 1 !important; /* 左侧位置 */
}

/* 联系信息部分样式 */
.footer-section {
  height: 200px;
  background: url(../assets/img/footer-bg.png) 100% no-repeat;
  background-size: 100% 100%;
  width: 100%;
  max-width: 1838px;
  margin: 0 auto;
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
}

.footer-decorative-image {
  position: absolute;
  width: 113px;
  height: 249px;
  object-fit: contain;
  top: 100px;
}

.footer-title {
  width: 136px;
  height: 11px;
  margin: 13px auto 0;
  position: relative;
  left: auto;
}

.footer-title-text {
  display: none !important; /* 隐藏"CONTACT US"文字 */
  width: 136px;
  height: 11px;
  overflow-wrap: break-word;
  color: rgba(140, 48, 0, 1);
  font-size: 15px;
  font-family: BookmanOldStyle;
  text-align: center;
  white-space: nowrap;
  line-height: 15px;
}

/* footer-contact 自适应 - 左中右布局，中间始终在屏幕中间 */
.footer-contact {
  width: 100% ;
  max-width: 1200px !important; /* 减小最大宽度，让元素更靠近 */
  height: auto !important;
  min-height: 168px !important;
  margin: 72px auto 22px 285px; /* 向右移动 */
  padding: 0 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: row ;
  justify-content: space-between !important; /* 左中右分布 */
  align-items: center !important;
  flex-wrap: wrap !important; /* 允许换行 */
  gap: 20px !important; /* 保持间距 */
}

/* 响应式设计 - 小屏幕时改为垂直布局 */
@media (max-width: 768px) {
  .footer-contact {
    display: flex;
    flex-direction: column !important; /* 小屏幕改为垂直布局 */
    justify-content: center !important;
    align-items: center !important;
  
    margin:0 !important;

  }
  
  .footer-phone,
  .footer-qrcode,
  .footer-address {
    order: unset !important; /* 重置 order */
    margin: 0 auto !important; /* 居中 */
  }

  .footer-address {
  width: 100% !important;
  max-width: 233px !important;
  height: auto !important;
  min-height: 139px !important;
  margin: 0 0 0 auto !important; /* 向右靠拢 */
  flex: 0 0 auto !important;
  order: 3 !important; 

}
.footer-phone {
  width: 100% !important;
  max-width: 105px !important;
  height: auto !important;
  min-height: 117px !important;
  
}
}

/* footer-phone 自适应 - 左侧 */
.footer-phone {
  width: 100% !important;
  max-width: 105px !important;
  height: auto !important;
  min-height: 117px !important;
  flex: 0 0 auto !important;
  order: 1 !important; /* 左侧位置 */
  margin-right: auto !important; /* 向左靠拢 */
}

.footer-phone-icon {
  background-color: rgba(158, 112, 82, 1);
  border-radius: 50%;
  height: 64px;
  margin-left: 22px;
  width: 64px;
}

.footer-phone-img {
  width: 30px;
  height: 32px;
  margin: 16px 0 0 17px;
}

.footer-phone-text {
  width: 105px;
  height: 38px;
  margin-top: 15px;
}

.footer-phone-label {
  width: 26px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  text-align: center;
  white-space: nowrap;
  line-height: 14px;
  margin-left: 41px;
}

.footer-phone-number {
  width: 105px;
  height: 13px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  text-align: center;
  white-space: nowrap;
  line-height: 16px;
  margin-top: 11px;
}

/* footer-qrcode 自适应 - 中间，始终位于屏幕中间，向右移动 */
.footer-qrcode {
  background-color: rgba(255, 255, 255, 1) !important;
  border-radius: 4px !important;
  width: 100% !important;
  max-width: 160px !important;
  height: auto !important;
  min-height: 160px !important;
  border: 2px solid rgba(203, 185, 159, 1) !important;
  margin: 8px 0 0 20px !important; /* 向右移动20px */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important;
  flex: 0 0 auto !important;
  order: 2 !important; /* 中间位置 */
}

.footer-qrcode-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* footer-address 自适应 - 右侧 */
.footer-address {
  width: 100% !important;
  max-width: 233px !important;
  height: auto !important;
  min-height: 139px !important;
  margin: 0 0 0 auto !important; /* 向右靠拢 */
  flex: 0 0 auto !important;
  order: 3 !important; 
 
}

.footer-address-icon {
  background-color: rgba(158, 112, 82, 1);
  border-radius: 50%;
  height: 64px;
  margin-left: 87px;
  width: 64px;
}

.footer-address-img {
  width: 28px;
  height: 34px;
  margin: 15px 0 0 18px;
}

.footer-address-label {
  width: 27px;
  height: 14px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 14px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  text-align: center;
  white-space: nowrap;
  line-height: 14px;
  margin: 15px 0 0 107px;
}

.footer-address-text {
  width: 233px;
  height: 36px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  text-align: center;
  line-height: 16px;
  margin-top: 10px;
}

/* footer-bottom 样式 */
.footer-bottom {
  min-height: 260px;
  height: auto;
  background: url(../assets/img/footer-bottom-bg.png) center bottom no-repeat;
  background-size: cover;
  width: 100%;
  max-width: 1920px;
  margin: 37px auto 0;
  padding: 20px 20px 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.footer-menu {
  width: 100% !important;
  max-width: 1200px !important;
  height: auto !important;
  margin: 40px auto 20px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  flex-wrap: wrap !important;
  gap: 15px !important;
}

.footer-menu-item {
  height: 16px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 16px;
  text-decoration: none;
  cursor: pointer;
}

.footer-menu-item:hover {
  opacity: 0.8;
}

.footer-menu-divider {
  background-color: rgba(222, 222, 222, 1);
  width: 1px;
  height: 16px;
  margin: 0 22px;
}

.footer-copyright {
  width: 100%;
  max-width: 800px;
  height: auto;
  margin: 0 auto;
  text-align: center;
}

.footer-copyright-text {
  width: 100%;
  height: auto;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  text-align: center;
  white-space: normal; /* Allow wrapping */
  line-height: 1.5;
  display: block;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .contact-wrapper {
    margin-top: 50px !important;
  }

  .box_25 {
    width: 100% !important;
    margin: 0 !important;
    padding: 20px !important;
    height: auto !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 10px !important;
  }

  .text_80 {
    font-size: 24px !important;
    width: auto !important;
    height: auto !important;
    margin: 10px 0 !important;
    order: -1 !important; /* Title on top */
  }

  .image_4, .image_7 {
    display: none !important; /* Simplify by hiding huge decorative images on mobile */
  }
  
  .footer-section {
    height: auto !important;
    background: #fdfbf7 !important; /* Fallback color */
    padding-bottom: 30px;
    margin: 0 !important;
  }
  
  .footer-contact {
    margin: 20px auto !important;
    flex-direction: column !important;
    gap: 30px !important;
    padding: 0 !important;
  }
  
  .footer-title {
    display: table; /* Center centering fix */
    margin: 20px auto !important;
  }

  .footer-title-text {
    display: block !important;
    font-size: 18px;
    margin-bottom: 20px;
  }

  /* Reset separate mobile styles to simplified flex column */
  .footer-phone, .footer-address, .footer-qrcode {
    width: 100% !important;
    max-width: none !important;
    min-height: auto !important;
    margin: 0 !important;
    flex: none !important;
    order: unset !important;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  /* Reset complex absolute/margin hacks */
  .footer-phone-icon, .footer-address-icon {
     margin: 0 0 10px 0 !important;
  }
  
  .footer-phone-label, .footer-address-label {
    margin: 5px 0 !important;
    width: auto;
  }
  
  .footer-phone-number, .footer-address-text {
    margin: 5px 0 !important;
    width: auto;
    text-align: center;
    height: auto;
    white-space: normal;
  }
  
  .footer-phone-text {
      width: auto;
      height: auto;
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
  }

  .footer-decorative-image {
    display: none;
  }
  
  .footer-address-img, .footer-phone-img {
     margin: 0;
     position: relative;
     top: 15px; /* Center in circle */
     left:18px
  }

  /* Footer Bottom Mobile */
  .footer-bottom {
    margin-top: 0;
    padding: 20px 10px;
    background-size: cover;
  }
  
  .footer-menu {
    margin: 20px 0 !important;
    gap: 10px !important;
  }
  
  .footer-menu-item {
    font-size: 14px;
    padding: 5px 10px;
  }
  
  .footer-menu-divider {
    display: none; /* Hide dividers on mobile for cleaner wrap */
  }
  
  .footer-copyright-text {
    font-size: 10px;
    padding: 0 10px;
  }
}
</style>

